import { v4 as uuid } from 'uuid';
import { BindersApi, UsersApi } from '../../Utils/apis';
import { iBinderFetch, noTenantFetch } from '../../Utils/iBinderFetch';
import { ImpersonateTenant } from '../../Utils/impersonateTenant';

const id = uuid();
const githubUrl = `https://github.com/iBinder/admins-ui/tree/main/${__filename}`;

// *****************************************************************************
// START - The part between START and END is the part that is added to the file.
// *****************************************************************************
const name = 'Delete many binders';
const description = 'Given a list of binder ids, all should be deleted.';

// The input model
export interface InputInterface {
  binderIds?: string[];
}

// The sample input, prefilled in the editor
const sample: InputInterface = {
  binderIds: ['']
};

// The actual function called with the input
/**
 *  async (props: InputInterface)
 * can also be written as
 *  async ({TEMPLATE_PROP, userId, documentId}: InputInterface)
 * @param param0
 * @returns
 */
const fn =
  ({ tenantId }) =>
  async (props: InputInterface) => {
    const tenantFetch = iBinderFetch({ tenantId });

    await ImpersonateTenant({ tenantId });

    await props.binderIds.forEach(async (binderId) => {
      await tenantFetch(`${BindersApi}/${binderId}`, {
        method: 'DELETE'
      });
    });

    return JSON.stringify({});
  };

// *****************************************************************************
// END - The part between START and END is the part that is added to the file.
// *****************************************************************************

export default {
  onSubmit:
    ({ tenantId }) =>
    async (jsonData) =>
      await fn({ tenantId })(jsonData),
  sample,
  id,
  name,
  description,
  githubUrl
};
